<script>
import CommonConstants from '../../common/Constants';

import Card from 'primevue/card';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Toolbar from 'primevue/toolbar';
import InputText from 'primevue/inputtext';
import GenericCustomMasterDataSelect from '../../components/generic/GenericCustomMasterDataSelect.vue'

import Service from '../../services/movement-instruction';
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  setup: () => ({ v$: useVuelidate() }),
  components: {
    Toolbar, Card, DataTable, Column, InputText, GenericCustomMasterDataSelect,
  },
  props: ['id', 'readOnly', 'lotDetails', 'headerData'],
  data() {
    return {
      submitted: false,
      productSpecDisabled: false,
      items: [],
      notes: [],
      idProductSpecificationHeader: null,
      productSpec: {
        description: null,
        note: null,
        testMethods: null,
        uoMCode: null,
        value: null,
        maxValue: null,
        minValue: null
      },
      productSpecDialogVisible: false,
      showExceptionNote: false
    }
  },
  mounted() {
  },
  validations() {
    return {
      productSpec: {
        description: { required },
        note: {},
        testMethods: {},
        uoMCode: {},
        value: {},
        maxValue: {},
        minValue: {}
      }
    }
  },
  computed: {
    constants() {
      return CommonConstants;
    }
  },
  watch: {
    'lotDetails.idRegistryProduct'() {
      this.loadData();
    },
    'headerData.laycanStartDate'() {
      this.loadData();
    },
    'idProductSpecificationHeader'() {
      this.loadNotes();
    }
  },
  methods: {
    loadData() {
      if (this.lotDetails?.idRegistryProduct && this.headerData?.laycanStartDate) {
        Service.productSpecHeaderDetails({ lotId: this.id }, response => {
          if (response.success) {
            this.items = response.data;
            if (response.data && response.data.length > 0) {
              this.idProductSpecificationHeader = response.data[0].idProductSpecificationHeader;
            }
          }
        });

      } else {
        this.items = [];
      }
    },
    loadNotes() {
      if (this.idProductSpecificationHeader) {
        let filters = [];
        let f = {
          operator: 'eq',
          value: this.idProductSpecificationHeader,
          property: 'IdProductSpecificationHeader'
        }
        filters.push(f);

        let params = {
          filter: JSON.stringify(filters),
        }
        Service.getProductSpecsNote(params, ({ success, data }) => {
          if (success) {
            this.notes = data;
          }
        });
      }
    },
    openProductSpecDialogEdit(data) {
      this.productSpec = { ...data };
      this.productSpecDialogVisible = true;
    },
    checkOldWithNull(id, oldV, newV) {
      let o = oldV == null ? '' : oldV;
      let n = newV == null ? '' : newV;
      let different = id && o != n;
      this.showExceptionNote = this.showExceptionNote || different;
      return different;
    },
    submitSaveProductSpec() {
      if (this.productSpec.id) {
        // PUT
        let body = {
          id: this.productSpec.id,
          value: this.productSpec.value,
          minValue: this.productSpec.minValue,
          maxValue: this.productSpec.maxValue
        }
        Service.updateProductSpecHeaderDetailsException(body, ({ success, message }) => {
          if (success) {
            this.productSpec = {};
            this.productSpecDialogVisible = false;
            this.loadData();
          } else {
            this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        })
      } else {
        // POST
        let body = {
          idMovementInstructionLot: this.id,
          idProductSpecificationDetail: this.productSpec.idProductSpecificationDetail,
          value: this.productSpec.value,
          minValue: this.productSpec.minValue,
          maxValue: this.productSpec.maxValue
        }
        Service.addProductSpecHeaderDetailsException(body, ({ success, message }) => {
          if (success) {
            this.productSpec = {};
            this.productSpecDialogVisible = false;
            this.loadData();
          } else {
            this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.custom-card-title {
  font-size: 18px;
}
</style>

<template>
  <main>
    <Dialog v-model:visible="productSpecDialogVisible" modal class="p-fluid">
      <div class="field">
        <label>{{ $t('description') }}</label>
        <InputText :disabled="true" v-model="productSpec.description"
          :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
      </div>
      <div class="field">
        <label>{{ $t('unitofMeasureCode') }}</label>
        <InputText :disabled="true" v-model="productSpec.uoMCode" :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
      </div>
      <div class="field">
        <label :class="{ 'p-error': v$.productSpec.minValue.$invalid && submitted }">{{
          $t('movementInstructions.minimumValue') }}</label>
        <InputText v-model="productSpec.minValue" :disabled="readOnly"
          :class="{ 'p-invalid': v$.productSpec.minValue.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true }" />
      </div>
      <div class="field">
        <label :class="{ 'p-error': v$.productSpec.maxValue.$invalid && submitted }">{{
          $t('movementInstructions.maximumValue') }}</label>
        <InputText v-model="productSpec.maxValue" :disabled="readOnly"
          :class="{ 'p-invalid': v$.productSpec.maxValue.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true }" />
      </div>
      <div class="field">
        <label :class="{ 'p-error': v$.productSpec.value.$invalid && submitted }">{{
          $t('movementInstructions.characteristicValue') }}</label>
        <InputText v-model="productSpec.value" :disabled="readOnly"
          :class="{ 'p-invalid': v$.productSpec.value.$invalid && submitted, 'w-full p-inputtext-sm mt-1 ': true }" />
      </div>
      <div class="field">
        <label>{{ $t('movementInstructions.samplingMethod') }}</label>
        <InputText :disabled="true" v-model="productSpec.testMethods"
          :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
      </div>
      <div class="field">
        <label>{{ $t('note') }}</label>
        <InputText :disabled="true" v-model="productSpec.note" :class="{ 'w-full p-inputtext-sm mt-1 ': true }" />
      </div>
      <template #footer>
        <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text"
          @click="productSpecDialogVisible = false" />
        <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text"
          @click="submitSaveProductSpec" :disabled="productSpecDisabled" />
      </template>
    </Dialog>
    <div class="grid">
      <div class="col-12">
        <div class="card">
          <div class="grid">
            <Card class="col-12">
              <template #content>
                <div class="grid mt-4">
                  <div class="col-12">
                    <DataTable :value="items" showGridlines stripedRows :reorderableColumns="true">
                      <template #header>
                        <Toolbar>
                          <template #start>
                            <div class="custom-card-title">{{ $t('movementInstructions.productSpecifications') }}</div>
                          </template>
                        </Toolbar>
                      </template>
                      <Column :exportable="false" style="min-width:8rem" :reorderableColumn="false">
                        <template #body="slotProps">
                          <ResponsiveButton icon="pi pi-pencil" :disabled="readOnly"
                            class="grid-action-btn p-button-rounded p-button-outlined"
                            @click="openProductSpecDialogEdit(slotProps.data)" />
                        </template>
                      </Column>
                      <Column field="description" :header="$t('description')" dataType="string" :sortable="true">
                        <template #body="element">
                          {{ element.data.description }}
                        </template>
                        <template #editor="{ data, field }">
                          <InputText type="string" v-model="data[field]" autofocus />
                        </template>
                      </Column>
                      <Column field="unitOfMeasure" :header="$t('unitofMeasureCode')" dataType="string"
                        :sortable="true">
                        <template #body="element">
                          {{ element.data.uoMCode }}
                        </template>
                        <template #editor="{ data, field }">
                          <GenericCustomMasterDataSelect :disabled="readOnly" class="w-full p-inputtext-sm mt-1 "
                            name="units-of-measure" v-model="data[field]"
                            api="masterdata/unit-of-measure-combo?getOnlyValid=true&scope=MovementInstruction"
                            :format="{ label: 'code', value: 'code' }" sortField="Code" />
                        </template>
                      </Column>

                      <Column field="minimumValue" :header="$t('movementInstructions.minimumValue')" dataType="number"
                        :sortable="true">
                        <template #body="element">
                          <span
                            :class="{ 'font-bold': checkOldWithNull(element.data.id, element.data.minValueOld, element.data.minValue) }"
                            :style="checkOldWithNull(element.data.id, element.data.minValueOld, element.data.minValue) ? 'color:red' : ''"
                            v-tooltip="checkOldWithNull(element.data.id, element.data.minValueOld, element.data.minValue) ? $t('messages.oldValue') + (element.data.minValueOld ?? '') : ''">
                            {{ element.data.minValue }}
                            <span
                              v-if="checkOldWithNull(element.data.id, element.data.minValueOld, element.data.minValue)"><i class="pi pi-exclamation-circle"></i></span>
                          </span>
                        </template>
                      </Column>
                      <Column field="maximumValue" :header="$t('movementInstructions.maximumValue')" dataType="number"
                        :sortable="true">
                        <template #body="element">
                          <span
                            :class="{ 'font-bold': checkOldWithNull(element.data.id, element.data.maxValueOld, element.data.maxValue) }"
                            :style="checkOldWithNull(element.data.id, element.data.maxValueOld, element.data.maxValue) ? 'color:red' : ''"
                            v-tooltip="checkOldWithNull(element.data.id, element.data.maxValueOld, element.data.maxValue) ? $t('messages.oldValue') + (element.data.maxValueOld ?? '') : ''">
                            {{ element.data.maxValue }}
                            <span
                              v-if="checkOldWithNull(element.data.id, element.data.maxValueOld, element.data.maxValue)"><i class="pi pi-exclamation-circle"></i></span>
                          </span>
                        </template>
                      </Column>
                      <Column field="characteristicValue" :header="$t('movementInstructions.characteristicValue')"
                        dataType="number" :sortable="true">
                        <template #body="element">
                          <span
                            :class="{ 'font-bold': checkOldWithNull(element.data.id, element.data.valueOld, element.data.value) }"
                            :style="checkOldWithNull(element.data.id, element.data.valueOld, element.data.value) ? 'color:red' : ''"
                            v-tooltip="checkOldWithNull(element.data.id, element.data.valueOld, element.data.value) ? $t('messages.oldValue') + (element.data.valueOld ?? '') : ''">
                            {{ element.data.value }}
                            <span
                              v-if="checkOldWithNull(element.data.id, element.data.valueOld, element.data.value)"><i class="pi pi-exclamation-circle"></i></span>
                          </span>
                        </template>
                      </Column>
                      <Column field="samplingMethod" :header="$t('movementInstructions.samplingMethod')"
                        dataType="string" :sortable="true">
                        <template #body="element">
                          {{ element.data.testMethods }}
                        </template>
                      </Column>
                      <Column field="note" :header="$t('movementInstructions.noteCodes')" dataType="string"
                        :sortable="true">
                        <template #body="element">
                          {{ element.data.noteCode }}
                        </template>
                      </Column>
                      <template #empty>
                        {{ $t('noRecordsFound') }}
                      </template>
                    </DataTable>
                  </div>
                </div>
              </template>
            </Card>
            <Card class="col-12">
              <template #content>
                <div class="grid">
                  <div class="col-12">
                    <DataTable :value="notes" showGridlines stripedRows :reorderableColumns="true">
                      <template #header>
                        <Toolbar>
                          <template #start>
                            <div class="custom-card-title">{{ $t('movementInstructions.notes') }}</div>
                          </template>
                        </Toolbar>
                      </template>
                      <Column field="code" :header="$t('code')" dataType="string" :sortable="true">
                        <template #body="element">
                          {{ element.data.code }}
                        </template>
                      </Column>
                      <Column field="description" :header="$t('description')" dataType="string" :sortable="true">
                        <template #body="element">
                          <span v-html="element.data.description"></span>
                        </template>
                      </Column>
                      <template #empty>
                        {{ $t('noRecordsFound') }}
                      </template>
                      <template #footer v-if="showExceptionNote">
                        <p class="font-bold" style="color:red"><i class="pi pi-exclamation-circle"></i>   {{ $t('messages.exceptionSpec') }}</p>
                      </template>
                    </DataTable>
                  </div>
                </div>
              </template>
            </Card>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
